import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export function LoadingState({ className, label = "Loading..." }: { className?: string; label?: string }) {
  return (
    <div className={cn("flex h-40 flex-col items-center justify-center gap-3 text-muted-foreground", className)}>
      <Loader2 className="h-5 w-5 animate-spin" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
